export const menuOptions = [
    {
        title: 'Órdenes',
        url: 'orders',
        state: 'active',
        permission: 'orders.list',
        category: 'operator',
        icon: 'orders',
    },

    {
        title: 'Plantillas',
        url: 'templates',
        state: 'inactive',
        permission: 'templates.list',
        category: 'operator',
        icon: 'template',
    },
    {
        title: 'Reglas',
        url: 'rules',
        state: 'inactive',
        permission: 'groups.list',
        category: 'operator',
        icon: 'rules',
    },
    //{
    //  title: 'Empresas',
    //url: 'companies',
    //state: 'inactive',
    //permission: 'companies.list',
    //category: 'configurator',
    //icon: 'companies',
    //},
    {
        title: 'Warehouses',
        url: 'companies/details',
        state: 'inactive',
        permission: 'warehouses.list',
        category: 'configurator',
        icon: 'companies',
    },
    {
        title: 'Usuarios',
        url: 'users',
        state: 'inactive',
        permission: 'users.list',
        category: 'configurator',
        icon: 'user',
    },
    // {
    //     title: 'Ajustes',
    //     url: 'settings',
    //     state: 'inactive',
    // },
    {
        title: '',
        url: 'logout',
        state: 'sign-off',
        icon: 'logout',
        id: 'logout',
    },
]

export const verifyPermission = (permision: string[]) => {
    return menuOptions.some((perm) => permision.includes(perm.url))
}

export const hasPermission = (
    userPermissions: string[],
    requiredPermissions: string[]
) => {
    // Si la opción no requiere permisos, permitimos el acceso
    if (requiredPermissions.length === 0) return true

    // Retorna true si el usuario tiene al menos uno de los permisos requeridos
    return requiredPermissions.some((permission) =>
        userPermissions.includes(permission)
    )
}
